import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {vnApp_pubinsights} from "../vnApp_pubinsights";

declare var ko: any;



export class usersEdit_template extends vnTemplate{

    protected twoFactorAuthenticationTooltipContent;
    protected twoFactorAuthenticationTooltip: infoButton_template;

    protected getTemplateHtml(): string{

        return `
            <div class="form-header">
                <input id="user-id" data-bind="value: idUser" type="hidden">
                <!-- ko ifnot: $data.idUser() -->
                <h3 class="form-title icon i-user-add">Add User</h3>
                <!-- /ko -->

                <!-- ko if: $data.idUser() -->
                <h3 class="form-title icon i-user-add">edit User</h3>
                <!-- /ko -->

                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title">personal info</strong>
                    <div class="form-group">
                        <legend class="form-legend">active</legend>
                        <div class="form-check-inline width-auto">
                            <input type="radio" name="isActive" id="active_yes" value="1" data-bind="checked: isActive, disable: disableActive" />
                            <label class="form-label" for="active_yes">Yes</label>
                        </div>
                        <div class="form-check-inline width-auto">
                            <input type="radio" name="isActive" id="active_no" value="0" data-bind="checked: isActive, disable: disableActive" />
                            <label class="form-label" for="active_no">No</label>
                        </div>
                    </div>
                    
                    <div class="form-group">
                        <label for="firstName" class="form-label">First Name</label>
                        <input id="firstName" data-bind="value: firstName, disable: disabledName" type="text" class="input-text">
                     </div>
                    <div class="form-group">
                        <label for="lastName" class="form-label">Last Name</label>
                        <input id="lastName" data-bind="value: lastName, disable: disabledName" type="text" class="input-text">
                     </div>
                    <div class="form-group">
                        <label for="loginName" class="form-label">User Name</label>
                        <input id="loginName" data-bind="value: loginName, disable: disabledUsername" type="text" class="input-text">
                    </div>
                    <div class="form-group">
                        <label for="email" class="form-label">Email</label>
                        <input id="email" data-bind="value: email, event: { blur: onBlurEmail }, disable: disabledEmail" type="email" class="input-text">
                    </div>
                
                    <!-- ko if: $data.idUser() -->
                     <div class="form-group">
                        <input id="change-password" type="checkbox" data-bind="checked: isChangingPassword, disable: disabledPassword">
                        <label for="change-password" class="form-label icon i-check">Change pubinsights Password?</label>
                    </div>
                    <!-- /ko -->

                    <div class="form-group-password" id="form-group-password", data-bind="css: { 'is-open': !$data.idUser()}">
                        <div class="form-group">
                            <label class="form-label" for="password">Password</label>
                            <input id="password" data-bind="value: password, disable: disabledPassword" type="password" class="input-pass">
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="passwordConfirmation">New Password Confirmation</label>
                            <input id="passwordConfirmation" data-bind="value: passwordConfirmation, disable: disabledPassword" type="password" class="input-pass">
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="oldPassword">Password of Logged User
                                <button class="w-tooltips icon i-tooltips" type="button">
                                    <span class="tooltips">Enter your OLD password here,<br>INCASE you are changing<br>to a new password</span>
                                </button>
                                
                            </label>
                            <input id="oldPassword" data-bind="value: oldPassword, disable: disabledPassword" type="password" class="input-pass">
                        </div>
                      
                    </div>

                    <div class="form-group">
                        <label for="2FA-select" style="display:flex" class="form-label width-tooltip">
                            Two-Factor Authentication
                            <div class="w-tooltips-adv pos-top short">
                                ${ this.twoFactorAuthenticationTooltip.getHtmlBuild() }
                            </div>
                        </label>
                        <select id="2FA-select" name="2FA" class="form-control" data-bind="value: twoFactorMethod">
                            <option value="disabled" data-bind="attr: { disabled: disabledTwoFactor}">Disabled</option>
                            <option value="email">Enabled via Email</option>
                        </select>
                    </div>
                    
                      <div class="form-group">
                        <label class="form-label label-oneline inputfile-label" for="profile-pic">Profile Picture</label>
                        <div id="dropzone">
                            <div id="my-drop-zone" data-bind="css: disabledProfileImage() ? '' : 'dropzone needsclick dz-clickable'" class=""></div>
                                <input id="profile-pic" data-bind="value: pictureUrl" type="hidden">
                            </div>
                      </div>
                    
                </div>
                <div class="form-body">
                    <strong class="form-sub-title">personal info</strong>
                    <div class="form-group">
                        <legend class="form-legend">Roles</legend>
                        <div data-bind="foreach: roles" >
                            <div class="form-check-inline">
                                <input data-bind="value: id, checked: $parent.selectedRoles, attr:{id:id}, disable: $parent.isRoleDisabled(id)" type="checkbox">
                                <label data-bind="text: name, attr:{for:id}" class="form-label icon i-check">Administrator</label>
                            </div>
                        </div>
                        
                    </div>
                    
                    <div data-bind="visible: !hasAdminRole()" class="form-group">
                                 
                        <legend class="form-legend">Brands</legend>
                        <div data-bind="foreach: brands">
                            <div class="form-check-inline">
                                <input data-bind="value: id, checked: $parent.selectedBrands, attr:{id: 'brand_' + id}, disable: $parent.isBrandDisabled(id)" type="checkbox">
                                <label class="form-label icon i-check" data-bind="text: name, attr:{for: 'brand_' + id}"></label>
                            </div>
                        </div>
                        <div class="margin-top">
                            <button class="btn border" type="button" id="select_all" data-bind="event: { click: onSelectAllAction}">Select All</button>
                            <button class="btn border" type="button" id="deselect_all" data-bind="event: { click: onDeselectAllAction}">Deselect All</button>
                        </div>
                        
                    </div>
                    
                    <div data-bind="visible: hasAdminRole()" class="form-group">
                        <p class="form-text">
                            Administrator is granted access to all of the Projects.
                        </p>
                    </div>
                    
                  

                </div>
            </div>
            <div class="form-footer">
                <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save User</button>  
            </div>

            `;
    }

    protected initPartial():void{

        this.twoFactorAuthenticationTooltipContent = `
        <p style="text-transform: none; white-space: normal">
        If 2FA is enabled, the additional configured authentication method will be prompted if the user’s device, browser, user agent, location, or connection are different from their previous login attempts in the last 30 days or if a login with 2FA has not occurred in the last 30 days.
        </p>
        `;

        this.twoFactorAuthenticationTooltip = new infoButton_template('twoFactorAuthenticationTooltip', this.getTemplateViewModel(), this.caller)
        this.twoFactorAuthenticationTooltip.setTitle('Two-Factor Authentication');
        this.twoFactorAuthenticationTooltip.setContent(this.twoFactorAuthenticationTooltipContent);
    }

    protected getTemplateName(): string{
        return "usersEdit-form-template";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-form", "w-form-large", "margin-top"];
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        let viewModel = {    idUser: ko.observable("")
                    ,firstName: ko.observable("")
                    ,lastName: ko.observable("")
                    ,loginName: ko.observable("")
                    ,email: ko.observable("")
                    ,pictureUrl: ko.observable(null)
                    ,password: ko.observable("")
                    ,roles: ko.observableArray([])
                    ,brands: ko.observableArray([])
                    ,selectedRoles: ko.observableArray([])
                    ,selectedBrands: ko.observableArray([])
                    ,passwordConfirmation: ko.observable("")
                    ,oldPassword: ko.observable("")
                    ,isActive: ko.observable("1")
                    ,isAdmin: ko.observable(false)
                    ,isPM: ko.observable(false)
                    ,isGM: ko.observable(false)
                    ,disableActive: ko.observable(true)
                    ,disabledName: ko.observable(true)
                    ,disabledEmail: ko.observable(true)
                    ,disabledUsername: ko.observable(true)
                    ,disabledPassword: ko.observable(true)
                    ,disabledProfileImage: ko.observable(true)
                    ,disabledRoles: ko.observableArray([])
                    ,disabledBrands: ko.observableArray([])
                    ,isChangingPassword: ko.observable(false)
                    ,hasAdminRole: ko.observable(false)
                    ,permissions: ko.observableArray(this.initPermissions(['user_edit_self', 'user_edit_advanced', 'user_edit_pm_config', 'user_edit_gm_config', 'user_edit_admin_config', 'users_form_admin']))
                    ,twoFactorMethod: ko.observable('email')
                    ,disabledTwoFactor: ko.observable(true)
                    ,isRoleDisabled: function(data){return ko.computed(function () { return huit_neuf_this.isRoleDisabled(data);}, this)}
                    ,isBrandDisabled: function(data){return ko.computed(function () { return huit_neuf_this.isBrandDisabled(data);}, this)}
                    ,onClickSave: function(data, event){ huit_neuf_this.onClickSave(); }
                    ,onClickCancel: function(data, event){ huit_neuf_this.onClickCancel(); }
                    ,onBlurEmail: function(data, event){ huit_neuf_this.onBlurEmail(); }
                    ,onSelectAllAction: function () { huit_neuf_this.onSelectAllAction(this.brands());}
                    ,onDeselectAllAction: function () { huit_neuf_this.onDeselectAllAction(this.brands());}
                };

        viewModel.selectedRoles.subscribe(function(checked) {
            huit_neuf_this.validateBrands();
        }, viewModel);

        viewModel.isChangingPassword.subscribe(function(checked) {
            huit_neuf_this.displayChangePassword(checked);
        }, viewModel);

        return viewModel;
    }


    protected validateBrands(){


        let checked = this.getTemplateViewModel().selectedRoles();
        if ((checked.indexOf(1) >= 0)) {
            this.getTemplateViewModel().hasAdminRole(true);
            this.setSelectedBrands([]);

            let disabledBrands = [];
            for(let b of this.getTemplateViewModel().brands()){
                disabledBrands.push(b.id);
            }
            //this.getTemplateViewModel().disabledBrands(disabledBrands);

        }else {
            this.getTemplateViewModel().hasAdminRole(false);
            //this.getTemplateViewModel().disabledBrands([]);
        }

    }


    protected onDeselectAllAction(allChannels){

        this.getTemplateViewModel().selectedBrands([]);
    }

    protected onSelectAllAction(allChannels){
        let allBrands = this.viewModel[this.idElement].brands();
        let disabledBrands = this.viewModel[this.idElement].disabledBrands();
        let brands = [];

        for(let b of allBrands) {
            if (disabledBrands.indexOf(b.id) < 0) {
                brands.push(b.id);
            }
        }
        this.getTemplateViewModel().selectedBrands(brands)

    }

    public setSelectedRoles(selectedRoles : Array<{id: number}>){
        let roles = [];
        for(let r of selectedRoles){

            roles.push(r.id);
        }
        this.getTemplateViewModel().selectedRoles(roles);
        this.validateBrands();
    }

    public setSelectedBrands(selectedBrands : Array<{id: number}>){
        let brands = [];
        for(let c of selectedBrands){
            brands.push(c.id);
        }
        this.getTemplateViewModel().selectedBrands(brands);
    }

    protected onClickSave(){
        this.caller.saveEditUser();
    }

    protected isRoleDisabled(data: number){
        let disabled: Array<number> = this.getTemplateViewModel().disabledRoles();

        for(let r of disabled){
            if(data == r){
                return true;
            }
        }
        return false;
    }

    protected isBrandDisabled(data: number){

        let disabled: Array<number> = this.getTemplateViewModel().disabledBrands();
        for(let c of disabled){
            if(data == c){
                return true;
            }
        }
        return false;
    }

    protected onClickCancel(){
        this.caller.cancelEditUser();
    }

    protected onBlurEmail(){

    }

    protected displayChangePassword(checked){
        console.log(checked);

        let element = document.querySelector("#form-group-password");

        if(checked){
            element.classList.add('is-open');
        }else{
            element.classList.remove('is-open');

            this.getTemplateViewModel().password("");
            this.getTemplateViewModel().oldPassword("");
            this.getTemplateViewModel().passwordConfirmation("");
        }

    }

    public setupForm(vnApp_pubinsights, allRoles, allBrands, userRoles, userBrands, loggedUserId, user){

        if(user.vnAppUser.id !== undefined && user.vnAppUser.id !== null){

            for(let r of user.vnAppUser.roles){

                if (r.id == vnApp_pubinsights.ROLE_NAME_ADMINISTRATOR) {

                    this.getTemplateViewModel().isAdmin(true);
                }

                if (r.id == vnApp_pubinsights.ROLE_GENERAL_MANAGER) {

                    this.getTemplateViewModel().isGM(true);
                }

                if (r.id == vnApp_pubinsights.ROLE_PRODUCT_MANAGER) {

                    this.getTemplateViewModel().isPM(true);
                }
            }

            this.getTemplateViewModel().twoFactorMethod(user.vnAppUser.twoFactorMethod ?? 'email');
        }

        let permissions = this.getTemplateViewModel().permissions();

        if (user.id == null && permissions['user_edit_advanced'].write) {

            this.getTemplateViewModel().disabledName(false);
            this.getTemplateViewModel().disabledEmail(false);
            this.getTemplateViewModel().disabledUsername(false);
            this.getTemplateViewModel().disabledPassword(false);
            this.getTemplateViewModel().disabledProfileImage(false);
            this.getTemplateViewModel().disableActive(false);
        }else {

            if ((user.id == loggedUserId && permissions['user_edit_self'].write) || permissions['user_edit_advanced'].write) {

                this.getTemplateViewModel().disabledName(false);
                this.getTemplateViewModel().disabledEmail(false);
                this.getTemplateViewModel().disabledUsername(false);
                this.getTemplateViewModel().disabledProfileImage(false);
            }

            if (permissions['user_edit_advanced'].write) {

                this.getTemplateViewModel().disableActive(false);
            }

            let isRestrictedRole = (this.getTemplateViewModel().isPM() || this.getTemplateViewModel().isGM() || this.getTemplateViewModel().isAdmin())
            let isAllowedToEditRestrictedRole = (
                permissions['user_edit_advanced'].write && (
                    (this.getTemplateViewModel().isPM() && permissions['user_edit_pm_config'].write)
                    || (this.getTemplateViewModel().isGM() && permissions['user_edit_gm_config'].write)
                    || (this.getTemplateViewModel().isAdmin() && permissions['user_edit_admin_config'].write)
                ));

            if ((user.id == loggedUserId && permissions['user_edit_self'].write) || (!isRestrictedRole && permissions['user_edit_advanced'].write) || isAllowedToEditRestrictedRole){

                this.getTemplateViewModel().disabledPassword(false);
            }
        }


        let disabledRoles = [];
        if (permissions['user_edit_advanced'].write) {

            if (!permissions['user_edit_pm_config'].write){

                disabledRoles.push(vnApp_pubinsights.ROLE_PRODUCT_MANAGER);
            }

            if (!permissions['user_edit_gm_config'].write){

                disabledRoles.push(vnApp_pubinsights.ROLE_GENERAL_MANAGER);
            }

            if (!permissions['user_edit_admin_config'].write){

                disabledRoles.push(vnApp_pubinsights.ROLE_NAME_ADMINISTRATOR);
            }
        }else {

            for (let role of allRoles) {

                disabledRoles.push(role.id);
            }
        }
        this.getTemplateViewModel().disabledRoles(disabledRoles);


        let disabledBrands = [];
        if (!permissions['user_edit_advanced'].write || !permissions['user_edit_brands'].write) {

            for (let brand of allBrands) {

                disabledBrands.push(brand.id);
            }
        }
        this.getTemplateViewModel().disabledBrands(disabledBrands);

        if(permissions['users_form_admin'] && permissions['users_form_admin'].write){
            this.getTemplateViewModel().disabledTwoFactor(false);
        }

        this.getTemplateViewModel().roles(allRoles);
        this.getTemplateViewModel().brands(allBrands);

    }


    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/usersEdit_template.ts